export function formatRupees(amount: string): string {
  const parsed = Number.parseFloat(Number.parseFloat(amount).toFixed(2));
  const prefix = parsed < 0 ? '-' : '';
  const grouped = Math.abs(parsed).toLocaleString('en-US', {
    maximumFractionDigits: 2,
  });
  return `${prefix} ₹${grouped}`;
}
